import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components';
import './Box.scss';

const Box = ({ additionalClass, backgroundColor, children, link, id }) => (
  <div className={`box ${link ? 'box--clickable' : ''} ${additionalClass}`}>
    {link ? (
      <Link to={link} id={id} arrow>
        <div
          className={`box__wrapper ${backgroundColor &&
            `box__wrapper--${backgroundColor}`}`}
        >
          {children}
        </div>
      </Link>
    ) : (
      <div
        id={id}
        className={`box__wrapper ${backgroundColor &&
          `box__wrapper--${backgroundColor}`}`}
      >
        {children}
      </div>
    )}
  </div>
);

Box.defaultProps = {
  additionalClass: '',
  backgroundColor: 'white',
  children: '',
  link: '',
  id: '',
};

Box.propTypes = {
  additionalClass: PropTypes.string,
  backgroundColor: PropTypes.string,
  link: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default Box;
